import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import DefaultCPButton from '../../buttons/defaultCommandPanelButton';

export function GenerateButton({ content, onClick, disabled }) {
  return (
    <DefaultCPButton
      content={content}
      onClick={onClick}
      disabled={disabled}
      icon={<FontAwesomeIcon icon={faPlay} />}
      color="primary"
    />
  );
}

GenerateButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

GenerateButton.defaultProps = {
  content: 'Сформувати',
  disabled: false,
};

export default GenerateButton;
